export class Platform 
{
    public cnc1:boolean = false;
    public cnc2:boolean = false;
    public multiTenant:boolean = false;
    public onPrem:boolean = false;
}